import * as assets from "./madnesAssetsAdapter";
import { getAudioTracks } from "../../framework/src/engine/madnes/MadnesAudio"
import * as madnes from "../../framework/src/engine/madnes/madnes";

import {to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";
import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_audio_volume, madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {
    openinfo,
    stars_infomenu_close,
    stars_infomenu_init, stars_infomenu_left,
    stars_infomenu_open, stars_infomenu_right,
    stars_infomenu_update,
    stars_print_desk
} from "../stars_reels";
import {stars_end_round_recalced, stars_rotate_run} from "../stars_core";
import {stars_print_reels} from "../stars_core_printer";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "cs", "en", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "fr", "nl", "it"
];

export function initGame(gameset) {

    madnes.set_ico_size(352, 190);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 352, 320);
    madnes_set_sprite('_blur', 352, 320);

    madnes_set_sprite('wing_left', 250, 450);
    madnes_set_sprite('wing_right', 250, 450);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function on_set_bet() {
    infomenu_update();
}

export function game_start() {
    main_phaser.time.desiredFps = 120;
    main_phaser.tweens.frameBased = true;
    stars_rotate_run()
}

export function print_desk() {
    stars_print_desk()
}

export function print_reels() {
    stars_print_reels();
}

export function infomenu_init() {
    stars_infomenu_init();
}

export function infomenu_open() {
    stars_infomenu_open();
}

export function infomenu_close() {
    stars_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    stars_infomenu_left();
}

export function infomenu_right() {
    stars_infomenu_right();
}

export function infomenu_update() {
    stars_infomenu_update();
}

export function end_round_recalced(eventName, {autostart}) {
    stars_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {}

export function preinfo_close() {}